import { render, staticRenderFns } from "./AddModuleTopics.vue?vue&type=template&id=9d286038&scoped=true"
import script from "./AddModuleTopics.vue?vue&type=script&lang=js"
export * from "./AddModuleTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d286038",
  null
  
)

export default component.exports